import React, { useEffect, useState } from "react";
import { Formik, Form, yupToFormErrors } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { LeadForm } from "./leadForm";
import { addLead, createMember } from "../../redux/actions/api/apiAction";
import SpinnerComponent from "../spinner/spinner";
import { StepButton } from "./stepButton";
import { getStaffsList } from "../../views/pages/gymPortion/reports/utils";
import { toastr } from "react-redux-toastr";
import { setOpenLeadModal } from "../../redux/actions/lead/leadAction";

// export const MultiStep = () => {
function LeadMainForm({
  firstName,
  lastName,
  email,
  phone,
  gender,
  edit,
  dob,
  id,
  metaData,
}) {
  const { loading } = useSelector((state) => state.gym);
  const [step, setStep] = useState(1);
  const [staffList, setStaffList] = useState([]);
  const [defaultAssignedStaff, setDefaultAssignedStaff] = useState(null);
  const dispatch = useDispatch();
  const { loginUser } = useSelector((state) => state.login);
  const { permissions, subAdminType, subAdminPermissions } = useSelector(
    (state) => state.permissions,
  );
  const getStaffListOptions = async () => {
    const staffList = await getStaffsList();
    setStaffList(staffList);
  };
  useEffect(() => {
    getStaffListOptions();
  }, []);
  useEffect(() => {
    if (staffList && staffList.length > 0) {
      let defaultStaff = staffList.find(
        (staff) =>
          staff.value ==
          JSON.parse(localStorage.getItem("connectToFitGymPanelUser"))?.id,
      );
      setDefaultAssignedStaff(defaultStaff || staffList[0]);
    }
  }, [staffList]);
  const handleSubmit = async (values, { setErrors, errors }) => {
    const {
      firstName,
      lastName,
      email,
      phone,
      gender,
      dob,
      referralSource,
      priority,
      assignedStaff,
      note,
    } = values;
    if (
      !firstName ||
      !lastName ||
      !assignedStaff ||
      (!email && !phone) ||
      !referralSource
    ) {
      return toastr.error("Error", "Please fill all required fields");
    }
    const payload = {
      firstName,
      lastName,
      email,
      phone,
      gender,
      dob,
      priority: priority,
      assignedTo: assignedStaff.value,
      referralSource: referralSource ? referralSource.value : null,
      note,
    };
    const assignedToMe =
      (loginUser.role == "STAFF" && !permissions["LED_VW_AL"]) ||
      (subAdminType == "SUB_ADMIN" && !subAdminPermissions["LED_VW_AL"])
        ? true
        : false;
    dispatch(addLead(payload, assignedToMe));
  };

  const submit = (values, { setErrors }) => {
    if (edit) {
      // handleSubmitForUpdate(values);
    } else {
      handleSubmit(values, { setErrors });
    }
  };

  const previous = () => setStep((step) => step - 1);

  const formSchema1 = Yup.object().shape({
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    phone: Yup.string().matches(
      new RegExp("[0-9]{12}"),
      "Phone number is not valid",
    ),
    email: Yup.string().email("Please enter valid Username i.e email"),
    dob: Yup.date(),
    gender: Yup.string().required("Gender is required"),
    assignedStaff: Yup.object()
      .nullable()
      .required("Staff is required"),
  });

  if (loading)
    return (
      <div
        style={{ height: "800px" }}
        className="d-flex flex-column align-items-center justify-content-center"
      >
        <SpinnerComponent />
        <h3>Please wait</h3>
      </div>
    );

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={{
          firstName,
          lastName,
          email,
          phone,
          gender,
          dob,
          id,
          referralSource: metaData?.referralSource || "",
          priority: "medium",
          assignedStaff: defaultAssignedStaff,
        }}
        onSubmit={(values, { setErrors }) => {
          submit(values, { setErrors });
        }}
        validationSchema={formSchema1}
      >
        {({
          errors,
          touched,
          values,
          setFieldValue,
          setErrors,
          handleBlur,
          setFieldTouched,
        }) => (
          <Form>
            <LeadForm
              setErrors={setErrors}
              errors={errors}
              touched={touched}
              handleBlur={handleBlur}
              setFieldTouched={setFieldTouched}
              values={values}
              setFieldValue={setFieldValue}
              staffList={staffList}
            />

            <StepButton
              step={step}
              previous={previous}
              edit={edit}
              title="Lead"
              onCancel={() => dispatch(setOpenLeadModal(false))}
            />
          </Form>
        )}
      </Formik>
    </>
  );
}
LeadMainForm.defaultProps = {
  name: "",
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  dob: "",
  id: "",
  handleSubmit: (values) => {},
  edit: false,
  gender: "",
  metaData: {},
};

export default LeadMainForm;
